export default {
  NUVEI_CARDS_LIST: "Liste des moyens de paiement",
  ADD_NUVEI_CARD: "Ajouter un moyen de paiement",
  NUVEI_CARDS: "Personnes ressources",
  NUVEI_CARD_ADDED: "Moyen de paiement ajouté",
  EDIT_NUVEI_CARD: "Modifier un moyen de paiement",
  NUVEI_CARD_UPDATED: "Moyen de paiement mise à jour",
  DELETE_THIS_NUVEI_CARD: "Supprimer ce moyen de paiement ?",
  NUVEI_CARD_DELETED: "Moyen de paiement supprimé",
  MISTER: "M.",
  MADAM: "Mme",
  NUVEI_CARD_TYPE: "Type de moyen de paiement",
  TITLE_MR: "M.",
  TITLE_MME: "Mme",
  VIEW_NUVEI_CARD: "Moyen de paiement",
  NO_ADDRESS_MESSAGE:
    "Ce moyen de paiement n'a pas d'adresse. Voulez-vous l'enregistrer avec l'adresse suivante par défaut?",
  ADDRESS_CONFIRMATION: "Confirmation d'adresse",
  PROPERTIES: "Propriétés",
  USE_DEFAULT_ADDRESS: "Utiliser l’adresse par défaut",
  WITHOUT_ADDRESS: "Ne pas mettre d’adresse",
  RETURN_TO_FROM: "Retourner au formulaire",
  SAME_NUVEI_CARDS:
    'Un ou plusieurs moyens de paiement ont déjà été enregistrés avec le prénom {firstname} et le nom {lastname}. S\'agit-il de la même personne ? Cliquez sur "Continuer" pour enregistrer si c\'est le cas, sinon cliquez sur "Annuler".',
  CARD_ID: "ID",
  CARD: "Carte",
  HOLDER: "Titulaire",
  EXPIRATION: "Expiration",
  IS_DEFAULT: "Par défaut",
  SET_AS_DEFAULT: "Définir comme moyen de paiement par défaut",
  CARD_HOLDER: "Titulaire de la carte",
  CARD_NUMBER: "Numéro de carte",
  CARD_EXPIRATION_DATE: "Date d’expiration",
  CARD_CVC: "CVC",
  SELECT_ORGANIZATION_FIRST: "Veuillez d'abord sélectionner une organisation",
  SELECT_CUSTOMER_FIRST: "Veuillez d'abord sélectionner un client",
  INCOMPLETE_CARD_NUMBER: "Numéro de carte incomplet",
};
